import React, { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/sections/Hero";
import AboutTobias from "@/components/sections/AboutTobias";
import Services from "@/components/sections/Services";
import ErfolgeSection from "@/components/sections/ErfolgeSection";
import ImpressionenGallery from "@/components/sections/ImpressionenGallery";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import TrustpilotReviews from "@/components/sections/TrustpilotReviews";
import VideoSection from "@/components/sections/VideoSection";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import MobileStickyCTA from "@/components/MobileStickyCTA";
import { SITE } from "@/lib/site-config";

const LandingPage = () => {
  useEffect(() => {
    document.title = `${SITE.brand.name} – NNR Coaching | Krafttraining & Ernährung Rodgau`;
    const descContent =
      "NNR Coaching mit Tobias Nunner in Rodgau. Nachhaltiges Krafttraining, Ernährung, Regeneration und Mindset – 1:1 Coaching, Trainings- und Ernährungspläne mit ehrlichem WhatsApp-Support.";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", descContent);

    // FAQ Schema.org (rich snippets in Google + AI search results)
    const existing = document.getElementById("faq-schema");
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.id = "faq-schema";
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: SITE.faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById("faq-schema");
      if (el) el.remove();
    };
  }, []);

  return (
    <div
      className="relative min-h-screen bg-[#5C6B49] text-[#F3F1E8]"
      data-testid="landing-page"
    >
      <Header />
      <main>
        <Hero />
        <VideoSection placement="ueber" eyebrow="Einblick" title="Über meinen Weg" />
        <VideoSection placement="startseite" eyebrow="Video" title="Willkommen" />
        <AboutTobias />
        <ErfolgeSection />
        <Services />
        <TrustpilotReviews />
        <VideoSection placement="coaching" eyebrow="Coaching" title="So arbeiten wir" />
        <ImpressionenGallery />
        <VideoSection placement="galerie" eyebrow="Galerie" title="Bewegtbild" />
        <VideoSection placement="referenzen" eyebrow="Stimmen" title="Kundenreferenzen" />
        <VideoSection placement="eigene_video_section" eyebrow="Video" title="Videos" />
        <VideoSection placement="landingpage" variant="inline" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <MobileStickyCTA />
    </div>
  );
};

export default LandingPage;
